// PaymentFail.tsx
import React, { useEffect } from "react";

const PaymentFail: React.FC = () => {
  useEffect(() => {
    if (window.parent && window.parent !== window) {
      window.parent.postMessage(
        { type: "TRANZILA_PAYMENT_FAIL" },
        window.location.origin
      );
    }
  }, []);

  return null;
};

export default PaymentFail;